import React, { useState, useEffect, useContext } from "react";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import {
  Drawer,
  Hidden,
  Toolbar,
  AppBar,
  List,
  ListItem,
} from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { AppContext } from "../contexts/appContext";
import styles from "./../assets/style/headerStyle";

const useStyles = makeStyles(styles);

const Header_Setting = () => {
  const { user } = useContext(AppContext);
  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const hideMobile = () => {
    setMobileOpen(false);
  };

  useEffect(() => {
    window.addEventListener("resize", hideMobile);
    return function cleanup() {
      window.removeEventListener("resize", hideMobile);
    };
  });

  const appBarClasses = classNames({
    [classes.appBar]: true,
    [classes["com7"]]: "com7",
  });

  const checkPath = () => {
    if (location.pathname.includes("/settings/type"))
      return (
        <ListItem className={classes.listItem}>
          Setting Type{" "}
          {!mobileOpen ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
        </ListItem>
      );
    else if (location.pathname.includes("/settings/template"))
      return (
        <ListItem className={classes.listItem}>
          Setting Template{" "}
          {!mobileOpen ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
        </ListItem>
      );
    else if (location.pathname.includes("/settings/user"))
      return (
        <ListItem className={classes.listItem}>
          Setting User{" "}
          {!mobileOpen ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
        </ListItem>
      );
    else if (location.pathname.includes("/settings/product"))
      return (
        <ListItem className={classes.listItem}>
          Setting Product{" "}
          {!mobileOpen ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
        </ListItem>
      );
    else return null;
  };

  return (
    <AppBar
      className={`${appBarClasses}`}
      style={{ color: "black", marginTop: "7vh", height: "7vh" }}
    >
      <Toolbar className={classes.container}>
        <Hidden smDown implementation="css">
          <List className={classes.list} style={{ display: "flex" }}>
            {user.manage_type && (
              <ListItem
                className={classNames(classes.listItem, "hoverThis")}
                onClick={() => history.push("/settings/type")}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  borderBottom:
                    location.pathname.indexOf("/settings/type") != -1
                      ? "3px solid #6ab23a"
                      : "",
                }}
              >
                Setting Type
              </ListItem>
            )}
            {user.manage_template && (
              <ListItem
                className={classNames(classes.listItem, "hoverThis")}
                onClick={() => history.push("/settings/template")}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  borderBottom:
                    location.pathname.indexOf("/settings/template") != -1
                      ? "3px solid #6ab23a"
                      : "",
                }}
              >
                Setting Template
              </ListItem>
            )}
            {user.manage_user && (
              <ListItem
                className={classNames(classes.listItem, "hoverThis")}
                onClick={() => history.push("/settings/user")}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  borderBottom:
                    location.pathname.indexOf("/settings/user") != -1
                      ? "3px solid #6ab23a"
                      : "",
                }}
              >
                Setting User
              </ListItem>
            )}
            {user.manage_product && (
              <ListItem
                className={classNames(classes.listItem, "hoverThis")}
                onClick={() => history.push("/settings/product")}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  borderBottom:
                    location.pathname.indexOf("/settings/product") != -1
                      ? "3px solid #6ab23a"
                      : "",
                }}
              >
                Setting Product
              </ListItem>
            )}
            {user.manage_group_bu && (
              <ListItem
                className={classNames(classes.listItem, "hoverThis")}
                onClick={() => history.push("/settings/group_bu")}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  borderBottom:
                    location.pathname.indexOf("/settings/group_bu") != -1
                      ? "3px solid #6ab23a"
                      : "",
                }}
              >
                Setting Group Bu
              </ListItem>
            )}
          </List>
        </Hidden>
        <Hidden mdUp>
          <List
            className={classes.list}
            style={{ margin: "auto", cursor: "pointer" }}
            onClick={handleDrawerToggle}
          >
            {checkPath()}
          </List>
        </Hidden>
      </Toolbar>
      <Hidden mdUp implementation="js">
        <Drawer
          variant="temporary"
          anchor={"top"}
          open={mobileOpen}
          classes={{
            paper: classes.drawerPaperTop,
          }}
          onClose={handleDrawerToggle}
        >
          <div className={classes.appResponsive}>
            <List className={classes.list} style={{ padding: "0px" }}>
              {user.manage_type && (
                <ListItem
                  className={classNames(classes.listItem, "hoverThis")}
                  onClick={() => history.push("/settings/type")}
                  style={{
                    cursor: "pointer",
                    borderBottom:
                      location.pathname.indexOf("/settings/type") != -1
                        ? "3px solid #6ab23a"
                        : "",
                  }}
                >
                  Setting Type
                </ListItem>
              )}
              {user.manage_template && (
                <ListItem
                  className={classNames(classes.listItem, "hoverThis")}
                  onClick={() => history.push("/settings/template")}
                  style={{
                    cursor: "pointer",
                    borderBottom:
                      location.pathname.indexOf("/settings/template") != -1
                        ? "3px solid #6ab23a"
                        : "",
                  }}
                >
                  Setting Template
                </ListItem>
              )}
              {user.manage_user && (
                <ListItem
                  className={classNames(classes.listItem, "hoverThis")}
                  onClick={() => history.push("/settings/user")}
                  style={{
                    cursor: "pointer",
                    borderBottom:
                      location.pathname.indexOf("/settings/user") != -1
                        ? "3px solid #6ab23a"
                        : "",
                  }}
                >
                  Setting User
                </ListItem>
              )}
              {user.manage_product && (
                <ListItem
                  className={classNames(classes.listItem, "hoverThis")}
                  onClick={() => history.push("/settings/product")}
                  style={{
                    cursor: "pointer",
                    borderBottom:
                      location.pathname.indexOf("/settings/product") != -1
                        ? "3px solid #6ab23a"
                        : "",
                  }}
                >
                  Setting Product
                </ListItem>
              )}
              {user.manage_group_bu && (
                <ListItem
                  className={classNames(classes.listItem, "hoverThis")}
                  onClick={() => history.push("/settings/group_bu")}
                  style={{
                    cursor: "pointer",
                    borderBottom:
                      location.pathname.indexOf("/settings/group_bu") != -1
                        ? "3px solid #6ab23a"
                        : "",
                  }}
                >
                  Setting Group Bu
                </ListItem>
              )}
            </List>
          </div>
        </Drawer>
      </Hidden>
    </AppBar>
  );
};

export default withRouter(Header_Setting);
